var _circle, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCfBrokenHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 52.0002,
    r: 52,
    fill: "url(#paint0_linear_3393_7524)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.7797 66.4022L47.0764 65.0442L51.3528 50.321L43.8408 51.7969L50.863 40.3411C47.9965 34.6638 42.0633 30.827 35.2817 31.0063C25.9077 31.2559 18.5174 39.0559 18.7658 48.4204C18.9138 54.0049 21.784 58.843 26.0214 61.8227L25.9747 61.8526L52.1678 81.0002L52.1709 80.9987L51.7797 66.4022Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1991 49.7682C87.8091 40.4209 80.7187 32.342 71.3707 31.7324C64.4692 31.2818 58.2726 35.0342 55.251 40.7808L53.3901 47.6483L59.5469 48.562L53.7699 62.5132L57.2831 64.0043L52.8604 80.833L79.4777 62.9127L79.431 62.8796C83.7845 60.0667 86.8351 55.3429 87.1986 49.7679L87.1991 49.7682Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3393_7524",
    x1: 104,
    y1: 0.000244141,
    x2: 0,
    y2: 104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03CEA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29ABE2"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfBrokenHeart);
export default __webpack_public_path__ + "static/media/cf_broken_heart.552900a6.svg";
export { ForwardRef as ReactComponent };